module.exports = __webpack_public_path__ + "static/media/icomoon.2d91cfbf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.eot
// module id = 1048
// module chunks = 114